uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

// x: rotation, counter clock wise
// y: distance from center (1==half height)
vec2 toPolarUV(vec2 uv, vec2 resolution) {
    vec2 p =  uv;
    p -= 0.5;
    p.x = p.x * (resolution.x / resolution.y);

    float pixelAngle = atan(p.x, p.y);
    float pixelDistance = length(p) * 2.0;

    return vec2(pixelAngle / 6.28318530717958623199592693708 + 0.5, pixelDistance);
}

// Returns a cell in vec3 formation:
//  xy: -1.0:1.0 position in cell
//  zw: x and y index of cell
vec4 makeCell(vec2 st, float width) {
    st = st + vec2(width / 2.); // This centers the grid
    vec2 p = (mod(st, width) / width) * 2.0 - 1.0;
    return vec4(p, floor(st / width));
}

vec4 makeRings(vec2 polar, vec2 width) {
    vec2 p = mod(polar, width) / width;
    return vec4(p, floor(polar / width));
}

vec4 ring(vec2 uv, vec2 resolution) {
    vec2 polar = toPolarUV(uv, resolution);
    polar.x += 0.3 * polar.y;
    float size = 5.0;
    vec4 ring = makeRings(polar, vec2(1.0/(sin(time*0.0006) * size + size + 2.0), 0.2));
    return ring;
}

void main() {

    vec2 uv = vUv;

    vec4 ringA = ring(uv, resolution);
    uv.x = 1.0 - uv.x;
    vec4 ringB = ring(uv, resolution);

    gl_FragColor = vec4(vec3(min(ringA.x * ringA.x, ringB.x)), 1.0);


}